// import React from "react";
// import Card from "react-bootstrap/Card";
// import { ImPointRight } from "react-icons/im";

// function AboutCard() {
//   return (
//     <Card className="quote-card-view">
//       <Card.Body>
//         <blockquote className="blockquote mb-0">
//           <p style={{ textAlign: "justify" }}>
//             Hi Everyone, I am <span className="purple">Pratik Khulge </span>
//             from <span className="purple"> Nagpur, India.</span>
//             <br />
//             I am studying <span className="purple">B.Tech</span> in Computer science from <br/><span className="purple">Lovely Professional University</span>, which is supposed to be completed by me in 2025..
//             <br />
//             With this in mind, I’m looking forward to delving into the IT environment after completing my studies. 
//             <br />
//             <br />
//             Apart from coding, some other activities that I love to do!
//           </p>
//           <ul>
//             <li className="about-activity">
//               <ImPointRight /> Playing Games
//             </li>
//             <li className="about-activity">
//               <ImPointRight /> Watching News
//             </li>
//             <li className="about-activity">
//               <ImPointRight /> Travelling
//             </li>
//           </ul>

//           <p style={{ color: "rgb(155 126 172)" }}>
//             "Success is not final, failure is not fatal: It is the courage to continue that counts."{" "}
//           </p>
//           <footer className="blockquote-footer">Winston Churchill</footer>
//         </blockquote>
//       </Card.Body>
//     </Card>
//   );
// }

// export default AboutCard;

import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");

  useEffect(() => {
    fetchRandomQuote();
  }, []);

  const fetchRandomQuote = () => {
    fetch(`https://api.quotable.io/random?minLength=50&maxLength=100&tags=famous-quotes|technology`)
      .then((response) => response.json())
      .then((data) => {
        setQuote(data.content);
        setAuthor(data.author);
      })
      .catch((error) => console.error("Error fetching quote:", error));
  };

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Pratik Khulge </span>
            from <span className="purple"> Nagpur, India.</span>
            <br />
            I am studying <span className="purple">B.Tech</span> in Computer science from <br/><span className="purple">Lovely Professional University</span>, which is supposed to be completed by me in 2025..
            <br />
            With this in mind, I’m looking forward to delving into the IT environment after completing my studies. 
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching News
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "{quote}"
          </p>
          <footer className="blockquote-footer">{author}</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;

